import axios, { AxiosInstance } from 'axios';
import { getVoiceFallbackClient } from './_shared';

// ── Campaign placements (/api/campaigns/{id}/placements) — F1 (2026-08-19) ─
// Verified against the live PlacementCreateRequest/PlacementResponse schema.
// static_qr's per-placement short links — one QR/short-link per physical
// placement (packaging, billboard, in-store), not per recipient.

export type CampaignPlacement = {
  id: string;
  campaign_id: string;
  placement_token: string;
  label: string;
  expires_at: string | null;
  scan_count: number;
  last_scanned_at: string | null;
  created_at: string;
  landing_url: string;
};

export async function fetchCampaignPlacements(campaignId: string, axiosInstance?: AxiosInstance): Promise<CampaignPlacement[]> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<CampaignPlacement[]>(`/api/campaigns/${campaignId}/placements`);
  return response.data;
}

export async function createCampaignPlacement(
  campaignId: string,
  payload: { label: string; expires_at?: string },
  axiosInstance?: AxiosInstance
): Promise<CampaignPlacement> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<CampaignPlacement>(`/api/campaigns/${campaignId}/placements`, payload);
  return response.data;
}
